export function formatDateTime(dateString, locale = 'uk-UA') {
	if (!dateString) return ''

	const normalized = String(dateString).replace(
		/(\.\d{3})\d+/,
		'$1'
	)

	const date = new Date(normalized)

	if (isNaN(date.getTime())) return ''

	return new Intl.DateTimeFormat(locale, {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
	}).format(date)
}

export function formatDate(dateString, locale = 'uk-UA') {
	if (!dateString) return ''

	const date = new Date(dateString)

	return new Intl.DateTimeFormat(locale, {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
	}).format(date)
}

export function getLastDaysRange(days = 2, options = {}) {
	const {
		includeToday = true,
		format = 'iso',
	} = options

	const now = new Date()

	const from = new Date(now)
	from.setDate(from.getDate() - days)

	if (!includeToday) {
		now.setDate(now.getDate() - 1)
	}

	const formatDate = (d) => {
		if (format === 'date') {
			return d.toISOString().split('T')[0]
		}
		return d.toISOString()
	}

	return {
		dateFrom: formatDate(from),
		dateTo: formatDate(now),
	}
}

export function buildApiDateRange(dateFrom, dateTo) {
	const result = {}

	if (dateFrom) {
		const start = new Date(dateFrom)
		start.setHours(0, 0, 0, 0)
		result.dateFrom = start.toISOString()
	}

	if (dateTo) {
		const end = new Date(dateTo)
		end.setHours(23, 59, 59, 999)
		result.dateTo = end.toISOString()
	}

	return result
}
